import { jsxRuntime } from "./runtime.js";
export const { jsx, jsxs, Fragment } = jsxRuntime;
